import axios from 'axios';
import { showAddToCartNotification } from '../common/CartNotification';

function addRedDot(v1) {
  // desktop
  let skuUL = document.getElementsByClassName('skuUL');
  for (var i = 0; i < skuUL.length; ++i) {
    let li = skuUL[i].getElementsByTagName("li");
    for (var j = 0; j < li.length; ++j) {
      let itemNum = li[j].getElementsByClassName('itemNum')[0].innerText;
      if (itemNum == v1) {
        li[j].classList.add("cart1");
      }
    }
  }

  // mobile
  let mobileItem = document.getElementsByClassName('mobileItem');
  for (var k = 0; k < mobileItem.length; ++k) {
    let itemNum = mobileItem[k].getElementsByClassName('itemNum')[0].innerText;
    if (itemNum == v1.toUpperCase()) {
      mobileItem[k].classList.add("cart1");
    }
  }

}

export const SampleOrderButton = ({
  itemnum, itemname, itemcolor
}) => {
  const errorMsgElement = document.getElementById('order-error-message');

  const handleOrderSample = async () => {
    try {
      const params = {
        "itemnum": itemnum,
        "itemname": itemname,
        "itemcolor": itemcolor,
        "itemunit": "Yard",
        "qty": 1,
        "price": 0,
        "type": "sample",
      };

      const response = await axios.post('/item-add', params, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
      updateUI(response);
    } catch (error) {
      handleErrors(error);
    }
  };

  const updateUI = (response) => {
    if (errorMsgElement) errorMsgElement.style.display = "none";

    let cartSampleCount = document.getElementById("cart-count");
    let mobileCartSampleCount = document.getElementById("mobile-cart-count");

    if (response.data.totalQuantity > 0) {
      cartSampleCount && cartSampleCount.classList.add("red-dot");
      mobileCartSampleCount && mobileCartSampleCount.classList.add("red-dot");
    } else {
      cartSampleCount && cartSampleCount.classList.remove("red-dot");
      mobileCartSampleCount && mobileCartSampleCount.classList.remove("red-dot");
    }

    addRedDot(itemnum);

    if (response.data.success) {
      showAddToCartNotification({
        itemName: response.data.itemName,
        itemNumber: response.data.itemNum,
        skuImg: response.data.skuImg,
        duration: 3000,
      });
    }
  };

  const handleErrors = (error) => {
    const data = error.response.data;
    if (errorMsgElement) {
      let message;
      switch (data.error) {
        case "MAX_SAMPLE_ORDER_REACHED":
        case "PERMISSION_DENIED":
          message = data.message_html;
          break;
        default:
          message = "An unknown error occurred.";
      }
      errorMsgElement.innerHTML = message;
      errorMsgElement.style.display = "block";
    }
  };

  return (
    <button onClick={handleOrderSample} type="button">
      ORDER A SAMPLE
    </button>
  );
};
